module.exports = __webpack_public_path__ + "img/intro_fact_1.39eff1dc.svg";